import { AdvancedOptionsFlags } from 'wizards/models/advanced-options-models';
import { AdvancedSettingsVirtualStepValue } from 'wizards/models/advanced-settings-vm-models';
import { CompressionEncryptionStepValue } from 'wizards/models/compression-encription-models';
import { SelectHostStepValue } from 'wizards/models/select-host-models';
import { VmwareHyperVBaseModel } from '../base/vmware-hyper-v-base-model';

export class ProxmoxFormModel extends VmwareHyperVBaseModel {
  advancedSettingsStep: AdvancedSettingsVirtualStepValue = {
    useChangeBlockTracking: true,
    useS3Acceleration: false,
    storageClass: 1,
    syntheticFull: false,
    valid: true
  };
  advancedOptionsFlags: AdvancedOptionsFlags = {
    ExcludePossible: true,
    UseS3AccelerationPossible: false,
    AzureAccessTierType: false,
    StorageClassSettingPossible: false,
    SyntheticFullSettingPossible: false,
    IgnoreBadSectorsPossible: true,
    DisableVSSPossible: true,
    UseVSSPossible: true,
    PrefetchBlockCountPossible: true,
    BlockSizeSettingPossible: true
  };
  AvailableMachinePlans: any[] = [];
  selectHostStep: SelectHostStepValue = { server: '', login: '', password: '', remember: true, valid: true };

  compressionEncryptionStep: CompressionEncryptionStepValue = {
    UseCompression: false,
    UseEncryption: false,
    EncryptionAlgorithm: 3,
    EncryptionKeySize: 256,
    EncryptionPassword: '',
    valid: true
  };

  constructor(
    public isUnix = false,
    public isNBF = false
  ) {
    super(isUnix, isNBF);
  }
}
